import HomeContent from "@/pages/home/components/HomeContent";
import { AdvisorProvider } from "@/components/feature/AdvisorProvider";
import { advisors } from "@/mocks/advisors";

export default function DanielBallesteros() {
  return (
    <AdvisorProvider advisor={advisors["daniel-ballesteros"]}>
      <HomeContent />
    </AdvisorProvider>
  );
}